import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';

import { setBasePath } from '@infios/uikit/utilities/base-path.js';
import { registerIcons } from '@infios/uikit/register-icons';
import '@infios/uikit/uikit.js';
import {
  Robot,
  Send,
  Close,
  Refresh,
  Plus,
  ContentCopy,
  ChevronDown,
  ChevronRight,
  AlertCircle,
  AlertCircleOutline,
  CheckCircle,
  Information,
  InformationOutline,
  Tools,
  HammerWrench,
  OpenInNew,
  ShieldCheckOutline,
  Creation,
  Account,
  LinkVariant,
  Stop,
  Logout,
} from '@infios/uikit/icons';

import './i18n';
import './index.css';
import { App } from './App';
import { loadRuntimeConfig } from './services/runtimeConfig';

registerIcons({
  robot: Robot,
  send: Send,
  close: Close,
  refresh: Refresh,
  plus: Plus,
  'content-copy': ContentCopy,
  copy: ContentCopy,
  'chevron-down': ChevronDown,
  'chevron-right': ChevronRight,
  'alert-circle': AlertCircle,
  'alert-circle-outline': AlertCircleOutline,
  'check-circle': CheckCircle,
  information: Information,
  'information-outline': InformationOutline,
  tools: Tools,
  'hammer-wrench': HammerWrench,
  'open-in-new': OpenInNew,
  'shield-check-outline': ShieldCheckOutline,
  creation: Creation,
  account: Account,
  'link-variant': LinkVariant,
  stop: Stop,
  logout: Logout,
});

// UIKit fetches icon SVGs relative to this base; assets are copied next to the
// bundle (see vite.config.ts viteStaticCopy). BASE_URL honours the relative
// base so this resolves correctly under any host mount path.
setBasePath(`${import.meta.env.BASE_URL}uikit`);

// Chat is conversational/transient — never auto-refetch session data by time;
// writes drive freshness.
const queryClient = new QueryClient({
  defaultOptions: { queries: { staleTime: Infinity } },
});

// Fetch runtime config (e.g. the postMessage origin allowlist) before mounting
// so the host handshake listener never runs with defaults.
void loadRuntimeConfig().then(() => {
  createRoot(document.getElementById('root')!).render(
    <StrictMode>
      <QueryClientProvider client={queryClient}>
        <App />
      </QueryClientProvider>
    </StrictMode>,
  );
});
